import { z } from '../zod';
import { DashboardUrlField } from '../shared/dashboardUrl';
import { AddressValidationSchema } from '../shared/addressValidationSchema';
import { PaginatedListSchema } from '../shared/paginatedList';

const CustomerShippingValidationSchema = z.object({
  name: z.string().optional().meta({
    description: 'Shipping recipient name.',
  }),
  phone: z.string().optional().meta({
    description: 'Shipping phone number.',
  }),
  address: AddressValidationSchema.optional().meta({
    description: 'Shipping address. This is separate from the top-level billing address.',
  }),
});

export const CustomerResponseValidationSchema = z
  .object({
    id: z.string().meta({
      description: 'Unique customer record ID.',
    }),
    name: z.string().optional().meta({
      description: 'Customer full name.',
    }),
    companyName: z.string().optional().meta({
      description: 'Customer company name.',
    }),
    email: z.string().meta({
      description: 'Primary customer email address.',
    }),
    phone: z.string().optional().meta({
      description: 'Customer phone number.',
    }),
    billingEmail: z.string().optional().meta({
      description: 'Billing email address. Can be different from the primary email.',
    }),
    address: AddressValidationSchema.optional().meta({
      description:
        'Billing address. This is separate from `shipping.address`, and the two may not match.',
    }),
    shipping: CustomerShippingValidationSchema.optional().meta({
      description:
        'Shipping details, including recipient name, phone, and shipping address. This is separate from the top-level billing address.',
    }),
    taxId: z.string().optional().meta({
      description: 'Customer tax ID.',
    }),
    taxIdType: z.string().optional().meta({
      description: 'Tax ID type.',
    }),
    sellerId: z.string().meta({
      description: 'Seller ID that owns this customer record.',
    }),
    stripeCustomerId: z.string().optional().meta({
      description: 'Linked Stripe customer ID.',
    }),
    createdAt: z.iso.datetime().meta({
      description: 'ISO 8601 timestamp when the customer record was created.',
    }),
    updatedAt: z.iso.datetime().meta({
      description: 'ISO 8601 timestamp when the customer record was last updated.',
    }),
  })
  .openapi('Customer', { description: '' });

export const GetCustomersResponseValidationSchema = PaginatedListSchema(
  CustomerResponseValidationSchema,
);

export const CustomerDetailResponseValidationSchema = z
  .object({
    data: CustomerResponseValidationSchema,
  })
  .meta({ id: 'CustomerDetailResponse', description: 'Envelope containing one customer.' });

export const CustomerToolDataValidationSchema = CustomerResponseValidationSchema.extend({
  dashboardUrl: DashboardUrlField,
});

export const CustomerDetailToolResponseValidationSchema = z.object({
  data: CustomerToolDataValidationSchema,
});

export const CustomersToolResponseValidationSchema = PaginatedListSchema(
  CustomerToolDataValidationSchema,
);
